<div class="dialog-container green-theme">
    <div class="dialog-header">
      <h4 class="dialog-heading">Manage '{{ season.title }}' data</h4>
      <button type="button" class="close-button" (click)="close()">
        <svg width="26px" height="24px" viewBox="0 0 26 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Nav-Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"
            stroke-linejoin="round">
            <g id="Genre" transform="translate(-1438.000000, -32.000000)" class="inner-stroke" stroke="#FFFFFF">
              <g id="Genre-Options">
                <g id="Close" transform="translate(1439.000000, 32.000000)">
                  <path d="M24,0 L0,24" id="Path"></path>
                  <path d="M0,0 L24,24" id="Path"></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </button>
    </div>
  
    <mat-dialog-content>
      <!-- <app-loader *ngIf="loading" color="#50e3c2"></app-loader> -->
      <div class="dialog-body">
        <!-- <h3 class="title"><ng-container *ngFor="let season of show.seasons; let i = index;">{{season.title}}</ng-container></h3> -->
        <div class="add-to-folder form-container"> 
          <!-- <p class="label">Available Groups<span class="deselect" (click)="deselectGroups()"><small>Deselect all ({{selectedCount}})</small></span></p> -->
          <!-- <input class="search"  id="searchGroup" (keyup)="getGroups()"
            placeholder="Find a group"
            [formControl]="searchControl"> -->
          <ul class="list" id="availableGroups">
            <li *ngFor="let episode of season.episodes; let i = index">
            <!-- <li *ngFor="let season of show.seasons; let i = index"> -->
              <mat-checkbox>
              <!-- <mat-checkbox [class]="group.isChecked ? 'dark-theme' : ''" [checked]="isGroupChecked(i)" (change)="groupChecked($event.checked, i, group.id)" [(ngModel)]="group.isChecked"> -->
                <span class="check-text">{{episode.title}}</span>
                <!-- <span class="check-text">{{season.title}}</span> -->
              </mat-checkbox>
            </li>
          </ul>
          <!-- <app-loader *ngIf="searchingGroups" color="#50e3c2"></app-loader> -->
        </div>
        <p class="note">Select episodes above</p>
        <div class="form-col buttons">
          <button class="form-button">Save</button>
          <button class="form-button">Assign Partner Group</button>
          <button class="form-button form-button-cancel">Delete</button>
          <!-- <button class="form-button form-button-cancel" (click)="close()">Cancel</button> -->
        </div>
      </div>
    </mat-dialog-content>
  </div>
  